import Box from '@mui/material/Box'
import Rating from '@mui/material/Rating'
import Typography from '@mui/material/Typography'
import React, { memo } from 'react'
import sx from './styles'

const RatingNumber = ({ rating }) => {
  return (
    <Box>
      <Typography
        component="legend"
        variant="h2"
        sx={sx.ratingNumber}
      >
        {rating}
        <Rating
          value={rating}
          precision={0.5}
          readOnly
          sx={sx.rating}
        />
      </Typography>
    </Box>
  )
}

export default memo(RatingNumber)
